var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamily(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_715_14854)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5822 11.0428C15.776 10.646 15.8775 10.2031 15.8775 9.7417C15.8775 9.31559 15.7898 8.91578 15.6326 8.55133H15.6375C15.5641 8.3863 15.4817 8.23038 15.3811 8.08357L15.3792 8.08072C15.0655 7.60087 14.8994 7.03798 14.8994 6.46587V6.45664C14.8994 4.79565 13.5521 3.44841 11.8911 3.44841C11.725 3.44841 11.5682 3.37458 11.4759 3.23617C10.9315 2.4795 10.0363 1.9812 9.03046 1.9812C8.02464 1.9812 7.12955 2.4795 6.58511 3.23617C6.49284 3.36536 6.33597 3.44841 6.16987 3.44841C6.14395 3.44841 6.1181 3.44874 6.09234 3.44939C4.46716 3.49054 3.16164 4.82157 3.16164 6.45664V6.46587C3.16164 7.03798 2.99554 7.60087 2.6818 8.08072L2.6797 8.08406C2.36729 8.56317 2.18359 9.12488 2.18359 9.7417C2.18359 10.2123 2.29433 10.646 2.47888 11.0428C2.54347 11.172 2.54347 11.3289 2.47888 11.4581C2.29433 11.8456 2.18359 12.2793 2.18359 12.7407C2.18359 14.3648 3.49393 15.6751 5.118 15.6751H12.9431C14.5672 15.6751 15.8775 14.3648 15.8775 12.7407C15.8775 12.2793 15.7668 11.8456 15.5822 11.4581C15.5176 11.3289 15.5176 11.172 15.5822 11.0428ZM4.4031 8.60605H4.39188L5.48488 10.7539C5.59731 13.3093 6.59458 10.7539 9.03046 10.7539C11.4663 10.7539 12.5286 13.5982 12.641 11.0428L13.6767 8.12758C13.6277 6.99251 12.8052 6.91284 12.641 6.91284H9.7049C8.54542 6.91284 7.4514 6.34534 6.79686 5.38709C6.68465 5.22894 6.45089 5.25685 6.37608 5.43361L6.30128 5.61037C6.09556 6.12206 5.70284 6.5128 5.21661 6.73608C5.20258 6.74073 5.18622 6.74771 5.16985 6.75468C5.15349 6.76166 5.13712 6.76864 5.1231 6.77329C4.90804 6.88493 4.4031 7.21985 4.3844 8.08506L4.39375 8.36416L4.4031 8.60605Z",
    fill: "url(#paint0_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5822 11.0428C15.776 10.646 15.8775 10.2031 15.8775 9.7417C15.8775 9.31559 15.7898 8.91578 15.6326 8.55133H15.6375C15.5641 8.3863 15.4817 8.23038 15.3811 8.08357L15.3792 8.08072C15.0655 7.60087 14.8994 7.03798 14.8994 6.46587V6.45664C14.8994 4.79565 13.5521 3.44841 11.8911 3.44841C11.725 3.44841 11.5682 3.37458 11.4759 3.23617C10.9315 2.4795 10.0363 1.9812 9.03046 1.9812C8.02464 1.9812 7.12955 2.4795 6.58511 3.23617C6.49284 3.36536 6.33597 3.44841 6.16987 3.44841C6.14395 3.44841 6.1181 3.44874 6.09234 3.44939C4.46716 3.49054 3.16164 4.82157 3.16164 6.45664V6.46587C3.16164 7.03798 2.99554 7.60087 2.6818 8.08072L2.6797 8.08406C2.36729 8.56317 2.18359 9.12488 2.18359 9.7417C2.18359 10.2123 2.29433 10.646 2.47888 11.0428C2.54347 11.172 2.54347 11.3289 2.47888 11.4581C2.29433 11.8456 2.18359 12.2793 2.18359 12.7407C2.18359 14.3648 3.49393 15.6751 5.118 15.6751H12.9431C14.5672 15.6751 15.8775 14.3648 15.8775 12.7407C15.8775 12.2793 15.7668 11.8456 15.5822 11.4581C15.5176 11.3289 15.5176 11.172 15.5822 11.0428ZM4.4031 8.60605H4.39188L5.48488 10.7539C5.59731 13.3093 6.59458 10.7539 9.03046 10.7539C11.4663 10.7539 12.5286 13.5982 12.641 11.0428L13.6767 8.12758C13.6277 6.99251 12.8052 6.91284 12.641 6.91284H9.7049C8.54542 6.91284 7.4514 6.34534 6.79686 5.38709C6.68465 5.22894 6.45089 5.25685 6.37608 5.43361L6.30128 5.61037C6.09556 6.12206 5.70284 6.5128 5.21661 6.73608C5.20258 6.74073 5.18622 6.74771 5.16985 6.75468C5.15349 6.76166 5.13712 6.76864 5.1231 6.77329C4.90804 6.88493 4.4031 7.21985 4.3844 8.08506L4.39375 8.36416L4.4031 8.60605Z",
    fill: "url(#paint1_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5822 11.0428C15.776 10.646 15.8775 10.2031 15.8775 9.7417C15.8775 9.31559 15.7898 8.91578 15.6326 8.55133H15.6375C15.5641 8.3863 15.4817 8.23038 15.3811 8.08357L15.3792 8.08072C15.0655 7.60087 14.8994 7.03798 14.8994 6.46587V6.45664C14.8994 4.79565 13.5521 3.44841 11.8911 3.44841C11.725 3.44841 11.5682 3.37458 11.4759 3.23617C10.9315 2.4795 10.0363 1.9812 9.03046 1.9812C8.02464 1.9812 7.12955 2.4795 6.58511 3.23617C6.49284 3.36536 6.33597 3.44841 6.16987 3.44841C6.14395 3.44841 6.1181 3.44874 6.09234 3.44939C4.46716 3.49054 3.16164 4.82157 3.16164 6.45664V6.46587C3.16164 7.03798 2.99554 7.60087 2.6818 8.08072L2.6797 8.08406C2.36729 8.56317 2.18359 9.12488 2.18359 9.7417C2.18359 10.2123 2.29433 10.646 2.47888 11.0428C2.54347 11.172 2.54347 11.3289 2.47888 11.4581C2.29433 11.8456 2.18359 12.2793 2.18359 12.7407C2.18359 14.3648 3.49393 15.6751 5.118 15.6751H12.9431C14.5672 15.6751 15.8775 14.3648 15.8775 12.7407C15.8775 12.2793 15.7668 11.8456 15.5822 11.4581C15.5176 11.3289 15.5176 11.172 15.5822 11.0428ZM4.4031 8.60605H4.39188L5.48488 10.7539C5.59731 13.3093 6.59458 10.7539 9.03046 10.7539C11.4663 10.7539 12.5286 13.5982 12.641 11.0428L13.6767 8.12758C13.6277 6.99251 12.8052 6.91284 12.641 6.91284H9.7049C8.54542 6.91284 7.4514 6.34534 6.79686 5.38709C6.68465 5.22894 6.45089 5.25685 6.37608 5.43361L6.30128 5.61037C6.09556 6.12206 5.70284 6.5128 5.21661 6.73608C5.20258 6.74073 5.18622 6.74771 5.16985 6.75468C5.15349 6.76166 5.13712 6.76864 5.1231 6.77329C4.90804 6.88493 4.4031 7.21985 4.3844 8.08506L4.39375 8.36416L4.4031 8.60605Z",
    fill: "url(#paint2_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5822 11.0428C15.776 10.646 15.8775 10.2031 15.8775 9.7417C15.8775 9.31559 15.7898 8.91578 15.6326 8.55133H15.6375C15.5641 8.3863 15.4817 8.23038 15.3811 8.08357L15.3792 8.08072C15.0655 7.60087 14.8994 7.03798 14.8994 6.46587V6.45664C14.8994 4.79565 13.5521 3.44841 11.8911 3.44841C11.725 3.44841 11.5682 3.37458 11.4759 3.23617C10.9315 2.4795 10.0363 1.9812 9.03046 1.9812C8.02464 1.9812 7.12955 2.4795 6.58511 3.23617C6.49284 3.36536 6.33597 3.44841 6.16987 3.44841C6.14395 3.44841 6.1181 3.44874 6.09234 3.44939C4.46716 3.49054 3.16164 4.82157 3.16164 6.45664V6.46587C3.16164 7.03798 2.99554 7.60087 2.6818 8.08072L2.6797 8.08406C2.36729 8.56317 2.18359 9.12488 2.18359 9.7417C2.18359 10.2123 2.29433 10.646 2.47888 11.0428C2.54347 11.172 2.54347 11.3289 2.47888 11.4581C2.29433 11.8456 2.18359 12.2793 2.18359 12.7407C2.18359 14.3648 3.49393 15.6751 5.118 15.6751H12.9431C14.5672 15.6751 15.8775 14.3648 15.8775 12.7407C15.8775 12.2793 15.7668 11.8456 15.5822 11.4581C15.5176 11.3289 15.5176 11.172 15.5822 11.0428ZM4.4031 8.60605H4.39188L5.48488 10.7539C5.59731 13.3093 6.59458 10.7539 9.03046 10.7539C11.4663 10.7539 12.5286 13.5982 12.641 11.0428L13.6767 8.12758C13.6277 6.99251 12.8052 6.91284 12.641 6.91284H9.7049C8.54542 6.91284 7.4514 6.34534 6.79686 5.38709C6.68465 5.22894 6.45089 5.25685 6.37608 5.43361L6.30128 5.61037C6.09556 6.12206 5.70284 6.5128 5.21661 6.73608C5.20258 6.74073 5.18622 6.74771 5.16985 6.75468C5.15349 6.76166 5.13712 6.76864 5.1231 6.77329C4.90804 6.88493 4.4031 7.21985 4.3844 8.08506L4.39375 8.36416L4.4031 8.60605Z",
    fill: "url(#paint3_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18359 21.6609C2.18359 17.8459 5.2763 14.7532 9.09134 14.7532C12.9064 14.7532 15.9991 17.8459 15.9991 21.6609V30.0188H2.18359V21.6609Z",
    fill: "url(#paint4_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.18359 21.6609C2.18359 17.8459 5.2763 14.7532 9.09134 14.7532C12.9064 14.7532 15.9991 17.8459 15.9991 21.6609V30.0188H2.18359V21.6609Z",
    fill: "url(#paint5_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.76017 11.2244C5.57049 11.2244 6.22738 10.5676 6.22738 9.75724C6.22738 8.94693 5.57049 8.29004 4.76017 8.29004C3.94986 8.29004 3.29297 8.94693 3.29297 9.75724C3.29297 10.5676 3.94986 11.2244 4.76017 11.2244Z",
    fill: "url(#paint6_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.432 11.2244C14.2424 11.2244 14.8993 10.5676 14.8993 9.75724C14.8993 8.94693 14.2424 8.29004 13.432 8.29004C12.6217 8.29004 11.9648 8.94693 11.9648 9.75724C11.9648 10.5676 12.6217 11.2244 13.432 11.2244Z",
    fill: "url(#paint7_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4325 10.7366C13.9734 10.7366 14.4119 10.2981 14.4119 9.75723C14.4119 9.21632 13.9734 8.77783 13.4325 8.77783C12.8916 8.77783 12.4531 9.21632 12.4531 9.75723C12.4531 10.2981 12.8916 10.7366 13.4325 10.7366Z",
    fill: "#FBC01C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77628 10.7366C5.31718 10.7366 5.75568 10.2981 5.75568 9.75723C5.75568 9.21632 5.31718 8.77783 4.77628 8.77783C4.23537 8.77783 3.79688 9.21632 3.79688 9.75723C3.79688 10.2981 4.23537 10.7366 4.77628 10.7366Z",
    fill: "#9E6F0E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.39224 8.60604H4.40347L4.39412 8.36416L4.38477 8.08505C4.40347 7.21984 4.9084 6.88492 5.12346 6.77328C5.13749 6.76863 5.15385 6.76165 5.17022 6.75468C5.18658 6.7477 5.20294 6.74072 5.21697 6.73607C5.7032 6.51279 6.09593 6.12205 6.30164 5.61036L6.37645 5.4336C6.45125 5.25684 6.68501 5.22893 6.79722 5.38708C7.45176 6.34533 8.54579 6.91283 9.70526 6.91283H12.6414C12.8055 6.91283 13.6281 6.9925 13.6771 8.12757L13.5688 10.9296C13.4564 13.485 11.4608 15.201 9.02493 15.201C6.58906 15.201 4.59351 13.485 4.48109 10.9296L4.39224 8.60604Z",
    fill: "url(#paint8_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39224 8.60604H4.40347L4.39412 8.36416L4.38477 8.08505C4.40347 7.21984 4.9084 6.88492 5.12346 6.77328C5.13749 6.76863 5.15385 6.76165 5.17022 6.75468C5.18658 6.7477 5.20294 6.74072 5.21697 6.73607C5.7032 6.51279 6.09593 6.12205 6.30164 5.61036L6.37645 5.4336C6.45125 5.25684 6.68501 5.22893 6.79722 5.38708C7.45176 6.34533 8.54579 6.91283 9.70526 6.91283H12.6414C12.8055 6.91283 13.6281 6.9925 13.6771 8.12757L13.5688 10.9296C13.4564 13.485 11.4608 15.201 9.02493 15.201C6.58906 15.201 4.59351 13.485 4.48109 10.9296L4.39224 8.60604Z",
    fill: "url(#paint9_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67328 9.55416L8.04998 11.1043C7.95108 11.4231 8.18844 11.742 8.5247 11.742H9.24173C9.57799 11.742 9.81535 11.4182 9.71645 11.1043L9.23184 9.55416C9.12799 9.21079 8.78207 9.21079 8.67328 9.55416Z",
    fill: "#B98711"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.68303 9.42794L8.19842 10.9781C8.09952 11.2969 8.33688 11.6158 8.67314 11.6158H9.39016C9.72642 11.6158 9.96378 11.292 9.86488 10.9781L9.38027 9.42794C9.27643 9.08457 8.79182 9.08457 8.68303 9.42794Z",
    fill: "url(#paint10_linear_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68303 9.42794L8.19842 10.9781C8.09952 11.2969 8.33688 11.6158 8.67314 11.6158H9.39016C9.72642 11.6158 9.96378 11.292 9.86488 10.9781L9.38027 9.42794C9.27643 9.08457 8.79182 9.08457 8.68303 9.42794Z",
    fill: "url(#paint11_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68303 9.42794L8.19842 10.9781C8.09952 11.2969 8.33688 11.6158 8.67314 11.6158H9.39016C9.72642 11.6158 9.96378 11.292 9.86488 10.9781L9.38027 9.42794C9.27643 9.08457 8.79182 9.08457 8.68303 9.42794Z",
    fill: "url(#paint12_linear_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68303 9.42794L8.19842 10.9781C8.09952 11.2969 8.33688 11.6158 8.67314 11.6158H9.39016C9.72642 11.6158 9.96378 11.292 9.86488 10.9781L9.38027 9.42794C9.27643 9.08457 8.79182 9.08457 8.68303 9.42794Z",
    fill: "url(#paint13_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.03089 12.4121C8.55607 12.4121 8.10975 12.2978 7.73464 12.0978C7.60644 12.0311 7.46874 12.1787 7.54946 12.2978C7.86284 12.7836 8.40888 13.1074 9.03089 13.1074C9.6529 13.1074 10.1989 12.7836 10.5123 12.2978C10.593 12.174 10.4553 12.0311 10.3271 12.0978C9.95204 12.2978 9.51046 12.4121 9.03089 12.4121Z",
    stroke: "url(#paint14_linear_715_14854)",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.03089 12.4121C8.55607 12.4121 8.10975 12.2978 7.73464 12.0978C7.60644 12.0311 7.46874 12.1787 7.54946 12.2978C7.86284 12.7836 8.40888 13.1074 9.03089 13.1074C9.6529 13.1074 10.1989 12.7836 10.5123 12.2978C10.593 12.174 10.4553 12.0311 10.3271 12.0978C9.95204 12.2978 9.51046 12.4121 9.03089 12.4121Z",
    fill: "#8A004F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0726 9.2384C10.3146 8.81277 10.6825 8.47656 11.4744 8.47656C11.8211 8.47656 12.1554 8.57262 12.4526 8.81277C12.6977 9.01085 12.6649 9.26428 12.4751 9.35919L11.968 9.64865C11.3737 9.45653 10.7165 9.43052 10.0726 9.2384Z",
    fill: "#635D5F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98993 9.2384C7.74792 8.81277 7.38001 8.47656 6.58813 8.47656C6.24142 8.47656 5.90709 8.57262 5.60991 8.81277C5.36479 9.01085 5.39762 9.26428 5.58744 9.35919L6.09445 9.64865C6.68881 9.45653 7.34604 9.43052 7.98993 9.2384Z",
    fill: "#635D5F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93294 8.13614L5.92894 8.13845C5.92882 8.13852 5.92871 8.13859 5.92859 8.13866C5.81285 8.20776 5.66283 8.17023 5.59344 8.05458C5.52396 7.93877 5.56165 7.78848 5.67746 7.71899L5.67798 7.71868L5.67892 7.71812L5.68161 7.71653L5.6902 7.71157C5.69732 7.7075 5.70723 7.70193 5.71977 7.69514C5.74485 7.68155 5.78052 7.66299 5.82553 7.64154C5.91538 7.59871 6.04344 7.54387 6.19951 7.49407C6.50942 7.39516 6.9428 7.31195 7.41064 7.39451C7.54364 7.41798 7.63243 7.54482 7.60896 7.67782C7.58549 7.81082 7.45865 7.89961 7.32565 7.87614C6.96207 7.81198 6.61294 7.87549 6.3482 7.95998C6.21694 8.00187 6.10964 8.0479 6.03596 8.08302C5.9992 8.10054 5.97107 8.11522 5.95277 8.12514C5.94363 8.13009 5.93697 8.13384 5.93294 8.13614Z",
    fill: "#A13730"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4333 7.71899C12.4334 7.71904 12.4335 7.71908 12.3076 7.92876L12.4333 7.71899C12.5491 7.78848 12.5868 7.93877 12.5173 8.05458C12.4479 8.17023 12.298 8.20783 12.1823 8.13873C12.1822 8.13869 12.1821 8.1386 12.1819 8.13848L12.1778 8.13614C12.1738 8.13384 12.1671 8.13009 12.158 8.12514C12.1397 8.11522 12.1116 8.10054 12.0748 8.08302C12.0011 8.0479 11.8938 8.00187 11.7626 7.95998C11.4978 7.87549 11.1487 7.81198 10.7851 7.87614C10.6521 7.89961 10.5253 7.81082 10.5018 7.67782C10.4783 7.54482 10.5671 7.41798 10.7001 7.39451C11.168 7.31195 11.6013 7.39516 11.9113 7.49407C12.0673 7.54387 12.1954 7.59871 12.2852 7.64154C12.3303 7.66299 12.3659 7.68155 12.391 7.69514C12.4035 7.70193 12.4134 7.7075 12.4206 7.71157L12.4292 7.71653L12.4318 7.71812L12.4328 7.71868L12.4333 7.71899Z",
    fill: "#A13730"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.2113 8.53003C11.8068 8.53003 12.3098 8.94061 12.4467 9.49544C12.4874 9.65449 12.3653 9.80615 12.2026 9.80615H10.1682C10.0387 9.80615 9.93513 9.68778 9.96103 9.55832C10.0757 8.9739 10.5898 8.53003 11.2113 8.53003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0225 8.77808C11.4738 8.77808 11.8363 9.14427 11.8363 9.59183C11.8363 9.66581 11.8252 9.73979 11.8067 9.80637H10.2347C10.2162 9.73609 10.2051 9.66581 10.2051 9.59183C10.2051 9.14427 10.5713 8.77808 11.0225 8.77808Z",
    fill: "url(#paint15_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5566 9.59179C10.5566 9.33287 10.7638 9.12573 11.0227 9.12573C11.2816 9.12573 11.4888 9.33287 11.4888 9.59179C11.4888 9.66947 11.4703 9.74345 11.437 9.80633H10.6121C10.5751 9.74345 10.5566 9.66947 10.5566 9.59179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9628 8.95014C11.0208 9.02762 10.8997 9.12207 10.762 9.22501C10.6243 9.32795 10.5222 9.40039 10.4643 9.32291C10.4063 9.24543 10.471 9.09917 10.6087 8.99623C10.7463 8.89329 10.9049 8.87266 10.9628 8.95014Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9628 8.95014C11.0208 9.02762 10.8997 9.12207 10.762 9.22501C10.6243 9.32795 10.5222 9.40039 10.4643 9.32291C10.4063 9.24543 10.471 9.09917 10.6087 8.99623C10.7463 8.89329 10.9049 8.87266 10.9628 8.95014Z",
    fill: "url(#paint16_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7483 9.48431C11.7183 9.2741 11.5953 9.11568 11.5376 9.06274L11.3008 9.32261L11.4076 9.53051L11.7483 9.48431Z",
    fill: "url(#paint17_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.85075 8.53003C6.25522 8.53003 5.75217 8.94061 5.61531 9.49545C5.57462 9.6545 5.69668 9.80615 5.85944 9.80615H7.89384C8.0233 9.80615 8.12687 9.68779 8.10098 9.55833C7.98631 8.9739 7.46846 8.53003 6.85075 8.53003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04032 8.77783C6.58906 8.77783 6.22656 9.14402 6.22656 9.59159C6.22656 9.66557 6.23766 9.73955 6.25615 9.80613H7.82819C7.84669 9.73585 7.85778 9.66557 7.85778 9.59159C7.85409 9.14402 7.49159 8.77783 7.04032 8.77783Z",
    fill: "url(#paint18_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50635 9.5918C7.50635 9.33287 7.29921 9.12573 7.04028 9.12573C6.78136 9.12573 6.57422 9.33287 6.57422 9.5918C6.57422 9.66947 6.59271 9.74345 6.626 9.80633H7.45086C7.48415 9.74345 7.50635 9.66947 7.50635 9.5918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78418 9.49575C7.78418 9.23299 7.57051 9.05782 7.51276 9.00488L7.25 9.25898L7.4117 9.58815L7.78418 9.49575Z",
    fill: "url(#paint19_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_715_14854)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.79425,
    cy: 9.12562,
    rx: 0.354964,
    ry: 0.179644,
    transform: "rotate(-27.914 6.79425 9.12562)",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.79425,
    cy: 9.12562,
    rx: 0.354964,
    ry: 0.179644,
    transform: "rotate(-27.914 6.79425 9.12562)",
    fill: "url(#paint20_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 7.5939C11.0949 7.52236 11.8262 7.55813 12.3151 7.90789",
    stroke: "#A35D4C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 7.5939C7.04963 7.52236 6.3183 7.55813 5.82942 7.90789",
    stroke: "#A35D4C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.56921 4.27362C5.1355 3.76927 5.95236 3.76417 6.41086 3.84568L6.77766 5.0225C6.54332 4.98684 6.33444 5.06835 6.15869 5.23647C5.74298 6.38579 4.31449 7.01954 3.65221 7.19275C3.51466 5.83253 3.59108 5.14477 4.56921 4.27362Z",
    fill: "url(#paint21_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56921 4.27362C5.1355 3.76927 5.95236 3.76417 6.41086 3.84568L6.77766 5.0225C6.54332 4.98684 6.33444 5.06835 6.15869 5.23647C5.74298 6.38579 4.31449 7.01954 3.65221 7.19275C3.51466 5.83253 3.59108 5.14477 4.56921 4.27362Z",
    fill: "url(#paint22_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48103 2.65363C7.44824 2.42561 6.34136 3.52478 6.23438 3.90687C7.64045 7.20808 9.79951 6.89347 12.1949 6.62731C13.6288 6.46799 13.8777 7.4842 14 7.80006C13.6026 4.10148 10.8347 3.17327 8.48103 2.65363Z",
    fill: "url(#paint23_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48103 2.65363C7.44824 2.42561 6.34136 3.52478 6.23438 3.90687C7.64045 7.20808 9.79951 6.89347 12.1949 6.62731C13.6288 6.46799 13.8777 7.4842 14 7.80006C13.6026 4.10148 10.8347 3.17327 8.48103 2.65363Z",
    fill: "url(#paint24_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48103 2.65363C7.44824 2.42561 6.34136 3.52478 6.23438 3.90687C7.64045 7.20808 9.79951 6.89347 12.1949 6.62731C13.6288 6.46799 13.8777 7.4842 14 7.80006C13.6026 4.10148 10.8347 3.17327 8.48103 2.65363Z",
    fill: "url(#paint25_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3986 11.0428C29.5924 10.646 29.6939 10.2031 29.6939 9.7417C29.6939 9.31559 29.6062 8.91578 29.449 8.55133H29.4539C29.3806 8.3863 29.2981 8.23038 29.1975 8.08357L29.1956 8.08072C28.8819 7.60087 28.7158 7.03798 28.7158 6.46587V6.45664C28.7158 4.79565 27.3685 3.44841 25.7075 3.44841C25.5414 3.44841 25.3846 3.37458 25.2923 3.23617C24.7479 2.4795 23.8527 1.9812 22.8469 1.9812C21.841 1.9812 20.946 2.4795 20.4015 3.23617C20.3092 3.36536 20.1524 3.44841 19.9863 3.44841C19.9604 3.44841 19.9345 3.44874 19.9087 3.44939C18.2836 3.49054 16.978 4.82157 16.978 6.45664V6.46587C16.978 7.03798 16.8119 7.60087 16.4982 8.08072L16.4961 8.08406C16.1837 8.56317 16 9.12488 16 9.7417C16 10.2123 16.1107 10.646 16.2953 11.0428C16.3599 11.172 16.3599 11.3289 16.2953 11.4581C16.1107 11.8456 16 12.2793 16 12.7407C16 14.3648 17.3103 15.6751 18.9344 15.6751H26.7595C28.3836 15.6751 29.6939 14.3648 29.6939 12.7407C29.6939 12.2793 29.5832 11.8456 29.3986 11.4581C29.334 11.3289 29.334 11.172 29.3986 11.0428ZM18.2195 8.60605H18.2083L19.3013 10.7539C19.4137 13.3093 20.411 10.7539 22.8469 10.7539C25.2827 10.7539 26.345 13.5982 26.4574 11.0428L27.4931 8.12758C27.4441 6.99251 26.6216 6.91284 26.4574 6.91284H23.5213C22.3618 6.91284 21.2678 6.34534 20.6133 5.38709C20.5011 5.22894 20.2673 5.25685 20.1925 5.43361L20.1177 5.61037C19.912 6.12206 19.5192 6.5128 19.033 6.73608C19.019 6.74073 19.0026 6.74771 18.9863 6.75468C18.9699 6.76166 18.9535 6.76864 18.9395 6.77329C18.7244 6.88493 18.2195 7.21985 18.2008 8.08506L18.2102 8.36416L18.2195 8.60605Z",
    fill: "url(#paint26_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3986 11.0428C29.5924 10.646 29.6939 10.2031 29.6939 9.7417C29.6939 9.31559 29.6062 8.91578 29.449 8.55133H29.4539C29.3806 8.3863 29.2981 8.23038 29.1975 8.08357L29.1956 8.08072C28.8819 7.60087 28.7158 7.03798 28.7158 6.46587V6.45664C28.7158 4.79565 27.3685 3.44841 25.7075 3.44841C25.5414 3.44841 25.3846 3.37458 25.2923 3.23617C24.7479 2.4795 23.8527 1.9812 22.8469 1.9812C21.841 1.9812 20.946 2.4795 20.4015 3.23617C20.3092 3.36536 20.1524 3.44841 19.9863 3.44841C19.9604 3.44841 19.9345 3.44874 19.9087 3.44939C18.2836 3.49054 16.978 4.82157 16.978 6.45664V6.46587C16.978 7.03798 16.8119 7.60087 16.4982 8.08072L16.4961 8.08406C16.1837 8.56317 16 9.12488 16 9.7417C16 10.2123 16.1107 10.646 16.2953 11.0428C16.3599 11.172 16.3599 11.3289 16.2953 11.4581C16.1107 11.8456 16 12.2793 16 12.7407C16 14.3648 17.3103 15.6751 18.9344 15.6751H26.7595C28.3836 15.6751 29.6939 14.3648 29.6939 12.7407C29.6939 12.2793 29.5832 11.8456 29.3986 11.4581C29.334 11.3289 29.334 11.172 29.3986 11.0428ZM18.2195 8.60605H18.2083L19.3013 10.7539C19.4137 13.3093 20.411 10.7539 22.8469 10.7539C25.2827 10.7539 26.345 13.5982 26.4574 11.0428L27.4931 8.12758C27.4441 6.99251 26.6216 6.91284 26.4574 6.91284H23.5213C22.3618 6.91284 21.2678 6.34534 20.6133 5.38709C20.5011 5.22894 20.2673 5.25685 20.1925 5.43361L20.1177 5.61037C19.912 6.12206 19.5192 6.5128 19.033 6.73608C19.019 6.74073 19.0026 6.74771 18.9863 6.75468C18.9699 6.76166 18.9535 6.76864 18.9395 6.77329C18.7244 6.88493 18.2195 7.21985 18.2008 8.08506L18.2102 8.36416L18.2195 8.60605Z",
    fill: "url(#paint27_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3986 11.0428C29.5924 10.646 29.6939 10.2031 29.6939 9.7417C29.6939 9.31559 29.6062 8.91578 29.449 8.55133H29.4539C29.3806 8.3863 29.2981 8.23038 29.1975 8.08357L29.1956 8.08072C28.8819 7.60087 28.7158 7.03798 28.7158 6.46587V6.45664C28.7158 4.79565 27.3685 3.44841 25.7075 3.44841C25.5414 3.44841 25.3846 3.37458 25.2923 3.23617C24.7479 2.4795 23.8527 1.9812 22.8469 1.9812C21.841 1.9812 20.946 2.4795 20.4015 3.23617C20.3092 3.36536 20.1524 3.44841 19.9863 3.44841C19.9604 3.44841 19.9345 3.44874 19.9087 3.44939C18.2836 3.49054 16.978 4.82157 16.978 6.45664V6.46587C16.978 7.03798 16.8119 7.60087 16.4982 8.08072L16.4961 8.08406C16.1837 8.56317 16 9.12488 16 9.7417C16 10.2123 16.1107 10.646 16.2953 11.0428C16.3599 11.172 16.3599 11.3289 16.2953 11.4581C16.1107 11.8456 16 12.2793 16 12.7407C16 14.3648 17.3103 15.6751 18.9344 15.6751H26.7595C28.3836 15.6751 29.6939 14.3648 29.6939 12.7407C29.6939 12.2793 29.5832 11.8456 29.3986 11.4581C29.334 11.3289 29.334 11.172 29.3986 11.0428ZM18.2195 8.60605H18.2083L19.3013 10.7539C19.4137 13.3093 20.411 10.7539 22.8469 10.7539C25.2827 10.7539 26.345 13.5982 26.4574 11.0428L27.4931 8.12758C27.4441 6.99251 26.6216 6.91284 26.4574 6.91284H23.5213C22.3618 6.91284 21.2678 6.34534 20.6133 5.38709C20.5011 5.22894 20.2673 5.25685 20.1925 5.43361L20.1177 5.61037C19.912 6.12206 19.5192 6.5128 19.033 6.73608C19.019 6.74073 19.0026 6.74771 18.9863 6.75468C18.9699 6.76166 18.9535 6.76864 18.9395 6.77329C18.7244 6.88493 18.2195 7.21985 18.2008 8.08506L18.2102 8.36416L18.2195 8.60605Z",
    fill: "url(#paint28_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3986 11.0428C29.5924 10.646 29.6939 10.2031 29.6939 9.7417C29.6939 9.31559 29.6062 8.91578 29.449 8.55133H29.4539C29.3806 8.3863 29.2981 8.23038 29.1975 8.08357L29.1956 8.08072C28.8819 7.60087 28.7158 7.03798 28.7158 6.46587V6.45664C28.7158 4.79565 27.3685 3.44841 25.7075 3.44841C25.5414 3.44841 25.3846 3.37458 25.2923 3.23617C24.7479 2.4795 23.8527 1.9812 22.8469 1.9812C21.841 1.9812 20.946 2.4795 20.4015 3.23617C20.3092 3.36536 20.1524 3.44841 19.9863 3.44841C19.9604 3.44841 19.9345 3.44874 19.9087 3.44939C18.2836 3.49054 16.978 4.82157 16.978 6.45664V6.46587C16.978 7.03798 16.8119 7.60087 16.4982 8.08072L16.4961 8.08406C16.1837 8.56317 16 9.12488 16 9.7417C16 10.2123 16.1107 10.646 16.2953 11.0428C16.3599 11.172 16.3599 11.3289 16.2953 11.4581C16.1107 11.8456 16 12.2793 16 12.7407C16 14.3648 17.3103 15.6751 18.9344 15.6751H26.7595C28.3836 15.6751 29.6939 14.3648 29.6939 12.7407C29.6939 12.2793 29.5832 11.8456 29.3986 11.4581C29.334 11.3289 29.334 11.172 29.3986 11.0428ZM18.2195 8.60605H18.2083L19.3013 10.7539C19.4137 13.3093 20.411 10.7539 22.8469 10.7539C25.2827 10.7539 26.345 13.5982 26.4574 11.0428L27.4931 8.12758C27.4441 6.99251 26.6216 6.91284 26.4574 6.91284H23.5213C22.3618 6.91284 21.2678 6.34534 20.6133 5.38709C20.5011 5.22894 20.2673 5.25685 20.1925 5.43361L20.1177 5.61037C19.912 6.12206 19.5192 6.5128 19.033 6.73608C19.019 6.74073 19.0026 6.74771 18.9863 6.75468C18.9699 6.76166 18.9535 6.76864 18.9395 6.77329C18.7244 6.88493 18.2195 7.21985 18.2008 8.08506L18.2102 8.36416L18.2195 8.60605Z",
    fill: "url(#paint29_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21.6609C16 17.8459 19.0927 14.7532 22.9077 14.7532C26.7228 14.7532 29.8155 17.8459 29.8155 21.6609V30.0188H16V21.6609Z",
    fill: "url(#paint30_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.6609C16 17.8459 19.0927 14.7532 22.9077 14.7532C26.7228 14.7532 29.8155 17.8459 29.8155 21.6609V30.0188H16V21.6609Z",
    fill: "url(#paint31_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5746 11.2244C19.3849 11.2244 20.0418 10.5676 20.0418 9.75724C20.0418 8.94693 19.3849 8.29004 18.5746 8.29004C17.7643 8.29004 17.1074 8.94693 17.1074 9.75724C17.1074 10.5676 17.7643 11.2244 18.5746 11.2244Z",
    fill: "url(#paint32_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.2485 11.2244C28.0588 11.2244 28.7157 10.5676 28.7157 9.75724C28.7157 8.94693 28.0588 8.29004 27.2485 8.29004C26.4381 8.29004 25.7812 8.94693 25.7812 9.75724C25.7812 10.5676 26.4381 11.2244 27.2485 11.2244Z",
    fill: "url(#paint33_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2489 10.7366C27.7898 10.7366 28.2283 10.2981 28.2283 9.75723C28.2283 9.21632 27.7898 8.77783 27.2489 8.77783C26.708 8.77783 26.2695 9.21632 26.2695 9.75723C26.2695 10.2981 26.708 10.7366 27.2489 10.7366Z",
    fill: "#FBC01C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5927 10.7366C19.1336 10.7366 19.5721 10.2981 19.5721 9.75723C19.5721 9.21632 19.1336 8.77783 18.5927 8.77783C18.0518 8.77783 17.6133 9.21632 17.6133 9.75723C17.6133 10.2981 18.0518 10.7366 18.5927 10.7366Z",
    fill: "#9E6F0E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2086 8.60604H18.2199L18.2105 8.36416L18.2012 8.08505C18.2199 7.21984 18.7248 6.88492 18.9399 6.77328C18.9539 6.76863 18.9703 6.76165 18.9866 6.75468C19.003 6.7477 19.0194 6.74072 19.0334 6.73607C19.5196 6.51279 19.9123 6.12205 20.118 5.61036L20.1929 5.4336C20.2677 5.25684 20.5014 5.22893 20.6136 5.38708C21.2682 6.34533 22.3622 6.91283 23.5217 6.91283H26.4578C26.6219 6.91283 27.4445 6.9925 27.4935 8.12757L27.3852 10.9296C27.2728 13.485 25.2772 15.201 22.8413 15.201C20.4055 15.201 18.4099 13.485 18.2975 10.9296L18.2086 8.60604Z",
    fill: "url(#paint34_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2086 8.60604H18.2199L18.2105 8.36416L18.2012 8.08505C18.2199 7.21984 18.7248 6.88492 18.9399 6.77328C18.9539 6.76863 18.9703 6.76165 18.9866 6.75468C19.003 6.7477 19.0194 6.74072 19.0334 6.73607C19.5196 6.51279 19.9123 6.12205 20.118 5.61036L20.1929 5.4336C20.2677 5.25684 20.5014 5.22893 20.6136 5.38708C21.2682 6.34533 22.3622 6.91283 23.5217 6.91283H26.4578C26.6219 6.91283 27.4445 6.9925 27.4935 8.12757L27.3852 10.9296C27.2728 13.485 25.2772 15.201 22.8413 15.201C20.4055 15.201 18.4099 13.485 18.2975 10.9296L18.2086 8.60604Z",
    fill: "url(#paint35_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4897 9.55416L21.8664 11.1043C21.7675 11.4231 22.0048 11.742 22.3411 11.742H23.0581C23.3944 11.742 23.6318 11.4182 23.5329 11.1043L23.0482 9.55416C22.9444 9.21079 22.5985 9.21079 22.4897 9.55416Z",
    fill: "#B98711"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4994 9.42794L22.0148 10.9781C21.9159 11.2969 22.1533 11.6158 22.4895 11.6158H23.2066C23.5428 11.6158 23.7802 11.292 23.6813 10.9781L23.1967 9.42794C23.0928 9.08457 22.6082 9.08457 22.4994 9.42794Z",
    fill: "url(#paint36_linear_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4994 9.42794L22.0148 10.9781C21.9159 11.2969 22.1533 11.6158 22.4895 11.6158H23.2066C23.5428 11.6158 23.7802 11.292 23.6813 10.9781L23.1967 9.42794C23.0928 9.08457 22.6082 9.08457 22.4994 9.42794Z",
    fill: "url(#paint37_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4994 9.42794L22.0148 10.9781C21.9159 11.2969 22.1533 11.6158 22.4895 11.6158H23.2066C23.5428 11.6158 23.7802 11.292 23.6813 10.9781L23.1967 9.42794C23.0928 9.08457 22.6082 9.08457 22.4994 9.42794Z",
    fill: "url(#paint38_linear_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4994 9.42794L22.0148 10.9781C21.9159 11.2969 22.1533 11.6158 22.4895 11.6158H23.2066C23.5428 11.6158 23.7802 11.292 23.6813 10.9781L23.1967 9.42794C23.0928 9.08457 22.6082 9.08457 22.4994 9.42794Z",
    fill: "url(#paint39_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8473 12.4121C22.3725 12.4121 21.9262 12.2978 21.551 12.0978C21.4228 12.0311 21.2851 12.1787 21.3659 12.2978C21.6792 12.7836 22.2253 13.1074 22.8473 13.1074C23.4693 13.1074 24.0153 12.7836 24.3287 12.2978C24.4094 12.174 24.2718 12.0311 24.1435 12.0978C23.7684 12.2978 23.3269 12.4121 22.8473 12.4121Z",
    stroke: "url(#paint40_linear_715_14854)",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8473 12.4121C22.3725 12.4121 21.9262 12.2978 21.551 12.0978C21.4228 12.0311 21.2851 12.1787 21.3659 12.2978C21.6792 12.7836 22.2253 13.1074 22.8473 13.1074C23.4693 13.1074 24.0153 12.7836 24.3287 12.2978C24.4094 12.174 24.2717 12.0311 24.1435 12.0978C23.7684 12.2978 23.3269 12.4121 22.8473 12.4121Z",
    fill: "#8A004F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.889 9.2384C24.131 8.81277 24.4989 8.47656 25.2908 8.47656C25.6375 8.47656 25.9718 8.57262 26.269 8.81277C26.5141 9.01085 26.4813 9.26428 26.2915 9.35919L25.7845 9.64865C25.1901 9.45653 24.5329 9.43052 23.889 9.2384Z",
    fill: "#635D5F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8063 9.2384C21.5643 8.81277 21.1964 8.47656 20.4045 8.47656C20.0578 8.47656 19.7235 8.57262 19.4263 8.81277C19.1812 9.01085 19.214 9.26428 19.4038 9.35919L19.9109 9.64865C20.5052 9.45653 21.1624 9.43052 21.8063 9.2384Z",
    fill: "#635D5F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7493 8.13614L19.7453 8.13845C19.7452 8.13852 19.7451 8.13859 19.745 8.13866C19.6293 8.20776 19.4792 8.17023 19.4098 8.05458C19.3404 7.93877 19.3781 7.78848 19.4939 7.71899L19.4944 7.71868L19.4953 7.71812L19.498 7.71653L19.5066 7.71157C19.5137 7.7075 19.5236 7.70193 19.5362 7.69514C19.5613 7.68155 19.5969 7.66299 19.6419 7.64154C19.7318 7.59871 19.8598 7.54387 20.0159 7.49407C20.3258 7.39516 20.7592 7.31195 21.227 7.39451C21.36 7.41798 21.4488 7.54482 21.4254 7.67782C21.4019 7.81082 21.2751 7.89961 21.1421 7.87614C20.7785 7.81198 20.4294 7.87549 20.1646 7.95998C20.0333 8.00187 19.926 8.0479 19.8524 8.08302C19.8156 8.10054 19.7875 8.11522 19.7692 8.12514C19.76 8.13009 19.7534 8.13384 19.7493 8.13614Z",
    fill: "#A13730"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2497 7.71899C26.2498 7.71904 26.2499 7.71908 26.124 7.92876L26.2497 7.71899C26.3655 7.78848 26.4032 7.93877 26.3337 8.05458C26.2643 8.17023 26.1145 8.20783 25.9987 8.13873C25.9986 8.13869 25.9985 8.1386 25.9983 8.13848L25.9942 8.13614C25.9902 8.13384 25.9835 8.13009 25.9744 8.12514C25.9561 8.11522 25.928 8.10054 25.8912 8.08302C25.8175 8.0479 25.7102 8.00187 25.579 7.95998C25.3142 7.87549 24.9651 7.81198 24.6015 7.87614C24.4685 7.89961 24.3417 7.81082 24.3182 7.67782C24.2947 7.54482 24.3835 7.41798 24.5165 7.39451C24.9844 7.31195 25.4178 7.39516 25.7277 7.49407C25.8837 7.54387 26.0118 7.59871 26.1016 7.64154C26.1467 7.66299 26.1823 7.68155 26.2074 7.69514C26.2199 7.70193 26.2299 7.7075 26.237 7.71157L26.2456 7.71653L26.2483 7.71812L26.2492 7.71868L26.2497 7.71899Z",
    fill: "#A13730"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.0277 8.53003C25.6232 8.53003 26.1262 8.94061 26.2631 9.49544C26.3038 9.65449 26.1817 9.80615 26.019 9.80615H23.9846C23.8551 9.80615 23.7515 9.68778 23.7774 9.55832C23.8921 8.9739 24.4062 8.53003 25.0277 8.53003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8389 8.77808C25.2902 8.77808 25.6527 9.14427 25.6527 9.59183C25.6527 9.66581 25.6416 9.73979 25.6231 9.80637H24.0511C24.0326 9.73609 24.0215 9.66581 24.0215 9.59183C24.0215 9.14427 24.3877 8.77808 24.8389 8.77808Z",
    fill: "url(#paint41_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.373 9.59179C24.373 9.33287 24.5802 9.12573 24.8391 9.12573C25.098 9.12573 25.3052 9.33287 25.3052 9.59179C25.3052 9.66947 25.2867 9.74345 25.2534 9.80633H24.4285C24.3915 9.74345 24.373 9.66947 24.373 9.59179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7792 8.95014C24.8372 9.02762 24.7161 9.12207 24.5784 9.22501C24.4407 9.32795 24.3386 9.40039 24.2807 9.32291C24.2227 9.24543 24.2874 9.09917 24.4251 8.99623C24.5627 8.89329 24.7213 8.87266 24.7792 8.95014Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7792 8.95014C24.8372 9.02762 24.7161 9.12207 24.5784 9.22501C24.4407 9.32795 24.3386 9.40039 24.2807 9.32291C24.2227 9.24543 24.2874 9.09917 24.4251 8.99623C24.5627 8.89329 24.7213 8.87266 24.7792 8.95014Z",
    fill: "url(#paint42_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5628 9.48431C25.5328 9.2741 25.4098 9.11568 25.352 9.06274L25.1152 9.32261L25.2221 9.53051L25.5628 9.48431Z",
    fill: "url(#paint43_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.6672 8.53003C20.0716 8.53003 19.5686 8.94061 19.4317 9.49545C19.391 9.6545 19.5131 9.80615 19.6758 9.80615H21.7102C21.8397 9.80615 21.9433 9.68779 21.9174 9.55833C21.8027 8.9739 21.2849 8.53003 20.6672 8.53003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8567 8.77783C20.4055 8.77783 20.043 9.14402 20.043 9.59159C20.043 9.66557 20.0541 9.73955 20.0726 9.80613H21.6446C21.6631 9.73585 21.6742 9.66557 21.6742 9.59159C21.6705 9.14402 21.308 8.77783 20.8567 8.77783Z",
    fill: "url(#paint44_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3228 9.5918C21.3228 9.33287 21.1156 9.12573 20.8567 9.12573C20.5978 9.12573 20.3906 9.33287 20.3906 9.5918C20.3906 9.66947 20.4091 9.74345 20.4424 9.80633H21.2673C21.3006 9.74345 21.3228 9.66947 21.3228 9.5918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5986 9.49575C21.5986 9.23299 21.385 9.05782 21.3272 9.00488L21.0645 9.25898L21.2262 9.58815L21.5986 9.49575Z",
    fill: "url(#paint45_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_f_715_14854)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6087,
    cy: 9.12562,
    rx: 0.354964,
    ry: 0.179644,
    transform: "rotate(-27.914 20.6087 9.12562)",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6087,
    cy: 9.12562,
    rx: 0.354964,
    ry: 0.179644,
    transform: "rotate(-27.914 20.6087 9.12562)",
    fill: "url(#paint46_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6152 7.5939C24.9094 7.52236 25.6407 7.55813 26.1296 7.90789",
    stroke: "#A35D4C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1582 7.5939C20.8641 7.52236 20.1328 7.55813 19.6439 7.90789",
    stroke: "#A35D4C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3837 4.27362C18.95 3.76927 19.7668 3.76417 20.2253 3.84568L20.5921 5.0225C20.3578 4.98684 20.1489 5.06835 19.9731 5.23647C19.5574 6.38579 18.1289 7.01954 17.4667 7.19275C17.3291 5.83253 17.4055 5.14477 18.3837 4.27362Z",
    fill: "url(#paint47_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3837 4.27362C18.95 3.76927 19.7668 3.76417 20.2253 3.84568L20.5921 5.0225C20.3578 4.98684 20.1489 5.06835 19.9731 5.23647C19.5574 6.38579 18.1289 7.01954 17.4667 7.19275C17.3291 5.83253 17.4055 5.14477 18.3837 4.27362Z",
    fill: "url(#paint48_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2974 2.65363C21.2646 2.42561 20.1578 3.52478 20.0508 3.90687C21.4569 7.20808 23.6159 6.89347 26.0113 6.62731C27.4452 6.46799 27.6941 7.4842 27.8164 7.80006C27.419 4.10148 24.6511 3.17327 22.2974 2.65363Z",
    fill: "url(#paint49_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2974 2.65363C21.2646 2.42561 20.1578 3.52478 20.0508 3.90687C21.4569 7.20808 23.6159 6.89347 26.0113 6.62731C27.4452 6.46799 27.6941 7.4842 27.8164 7.80006C27.419 4.10148 24.6511 3.17327 22.2974 2.65363Z",
    fill: "url(#paint50_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2974 2.65363C21.2646 2.42561 20.1578 3.52478 20.0508 3.90687C21.4569 7.20808 23.6159 6.89347 26.0113 6.62731C27.4452 6.46799 27.6941 7.4842 27.8164 7.80006C27.419 4.10148 24.6511 3.17327 22.2974 2.65363Z",
    fill: "url(#paint51_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.8516 30.0188H3.33203C4.33203 27.886 6.54249 26.3391 9.04924 26.3391C11.556 26.3391 13.832 27.8547 14.8516 30.0188Z",
    fill: "url(#paint52_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8516 30.0188H3.33203C4.33203 27.886 6.54249 26.3391 9.04924 26.3391C11.556 26.3391 13.832 27.8547 14.8516 30.0188Z",
    fill: "url(#paint53_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8516 30.0188H3.33203C4.33203 27.886 6.54249 26.3391 9.04924 26.3391C11.556 26.3391 13.832 27.8547 14.8516 30.0188Z",
    fill: "url(#paint54_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8516 30.0188H3.33203C4.33203 27.886 6.54249 26.3391 9.04924 26.3391C11.556 26.3391 13.832 27.8547 14.8516 30.0188Z",
    fill: "url(#paint55_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.668 30.0188H17.1484C18.1484 27.886 20.3589 26.3391 22.8657 26.3391C25.3724 26.3391 27.6484 27.8547 28.668 30.0188Z",
    fill: "url(#paint56_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.668 30.0188H17.1484C18.1484 27.886 20.3589 26.3391 22.8657 26.3391C25.3724 26.3391 27.6484 27.8547 28.668 30.0188Z",
    fill: "url(#paint57_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.668 30.0188H17.1484C18.1484 27.886 20.3589 26.3391 22.8657 26.3391C25.3724 26.3391 27.6484 27.8547 28.668 30.0188Z",
    fill: "url(#paint58_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.668 30.0188H17.1484C18.1484 27.886 20.3589 26.3391 22.8657 26.3391C25.3724 26.3391 27.6484 27.8547 28.668 30.0188Z",
    fill: "url(#paint59_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4926 25.6331L12.8776 24.5969L11.7838 25.8079L12.4853 27.3624C12.6227 27.6668 13.0141 27.7536 13.2672 27.5358L14.5488 26.4329C14.8024 26.2147 14.7742 25.8138 14.4926 25.6331Z",
    fill: "url(#paint60_linear_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4926 25.6331L12.8776 24.5969L11.7838 25.8079L12.4853 27.3624C12.6227 27.6668 13.0141 27.7536 13.2672 27.5358L14.5488 26.4329C14.8024 26.2147 14.7742 25.8138 14.4926 25.6331Z",
    fill: "url(#paint61_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4926 25.6331L12.8776 24.5969L11.7838 25.8079L12.4853 27.3624C12.6227 27.6668 13.0141 27.7536 13.2672 27.5358L14.5488 26.4329C14.8024 26.2147 14.7742 25.8138 14.4926 25.6331Z",
    fill: "url(#paint62_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.309 25.6331L26.694 24.5969L25.6002 25.8079L26.3018 27.3624C26.4391 27.6668 26.8305 27.7536 27.0836 27.5358L28.3652 26.4329C28.6188 26.2147 28.5907 25.8138 28.309 25.6331Z",
    fill: "url(#paint63_linear_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.309 25.6331L26.694 24.5969L25.6002 25.8079L26.3018 27.3624C26.4391 27.6668 26.8305 27.7536 27.0836 27.5358L28.3652 26.4329C28.6188 26.2147 28.5907 25.8138 28.309 25.6331Z",
    fill: "url(#paint64_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.309 25.6331L26.694 24.5969L25.6002 25.8079L26.3018 27.3624C26.4391 27.6668 26.8305 27.7536 27.0836 27.5358L28.3652 26.4329C28.6188 26.2147 28.5907 25.8138 28.309 25.6331Z",
    fill: "url(#paint65_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.67924 25.6331L5.2943 24.5969L6.38805 25.8079L5.68653 27.3624C5.54917 27.6668 5.15776 27.7536 4.90464 27.5358L3.6231 26.4329C3.36949 26.2147 3.39763 25.8138 3.67924 25.6331Z",
    fill: "url(#paint66_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67924 25.6331L5.2943 24.5969L6.38805 25.8079L5.68653 27.3624C5.54917 27.6668 5.15776 27.7536 4.90464 27.5358L3.6231 26.4329C3.36949 26.2147 3.39763 25.8138 3.67924 25.6331Z",
    fill: "url(#paint67_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4937 25.6331L19.1088 24.5969L20.2025 25.8079L19.501 27.3624C19.3636 27.6668 18.9722 27.7536 18.7191 27.5358L17.4375 26.4329C17.1839 26.2147 17.2121 25.8138 17.4937 25.6331Z",
    fill: "url(#paint68_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4937 25.6331L19.1088 24.5969L20.2025 25.8079L19.501 27.3624C19.3636 27.6668 18.9722 27.7536 18.7191 27.5358L17.4375 26.4329C17.1839 26.2147 17.2121 25.8138 17.4937 25.6331Z",
    fill: "url(#paint69_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 13.0078,
    cy: 22.6926,
    r: 1.2793,
    fill: "url(#paint70_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8223,
    cy: 22.6926,
    r: 1.2793,
    fill: "url(#paint71_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.2793,
    transform: "matrix(-1 0 0 1 5.17188 22.6926)",
    fill: "url(#paint72_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.2793,
    transform: "matrix(-1 0 0 1 18.9863 22.6926)",
    fill: "url(#paint73_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_f_715_14854)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.0073,
    cy: 22.6926,
    r: 0.833496,
    fill: "#FBC01C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_f_715_14854)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.8218,
    cy: 22.6926,
    r: 0.833496,
    fill: "#FBC01C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_f_715_14854)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 0.833496,
    transform: "matrix(-1 0 0 1 5.17041 22.6926)",
    fill: "#9E6F0E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_f_715_14854)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 0.833496,
    transform: "matrix(-1 0 0 1 18.9868 22.6926)",
    fill: "#9E6F0E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.9668 18.3547H13.1836V23.5579C13.1836 25.8231 11.3442 27.6594 9.0752 27.6594C6.80619 27.6594 4.9668 25.8231 4.9668 23.5579V18.3547Z",
    fill: "url(#paint74_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9668 18.3547H13.1836V23.5579C13.1836 25.8231 11.3442 27.6594 9.0752 27.6594C6.80619 27.6594 4.9668 25.8231 4.9668 23.5579V18.3547Z",
    fill: "url(#paint75_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9668 18.3547H13.1836V23.5579C13.1836 25.8231 11.3442 27.6594 9.0752 27.6594C6.80619 27.6594 4.9668 25.8231 4.9668 23.5579V18.3547Z",
    fill: "url(#paint76_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9668 18.3547H13.1836V23.5579C13.1836 25.8231 11.3442 27.6594 9.0752 27.6594C6.80619 27.6594 4.9668 25.8231 4.9668 23.5579V18.3547Z",
    fill: "url(#paint77_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7832 18.3547H27V23.5579C27 25.8231 25.1606 27.6594 22.8916 27.6594C20.6226 27.6594 18.7832 25.8231 18.7832 23.5579V18.3547Z",
    fill: "url(#paint78_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7832 18.3547H27V23.5579C27 25.8231 25.1606 27.6594 22.8916 27.6594C20.6226 27.6594 18.7832 25.8231 18.7832 23.5579V18.3547Z",
    fill: "url(#paint79_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7832 18.3547H27V23.5579C27 25.8231 25.1606 27.6594 22.8916 27.6594C20.6226 27.6594 18.7832 25.8231 18.7832 23.5579V18.3547Z",
    fill: "url(#paint80_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7832 18.3547H27V23.5579C27 25.8231 25.1606 27.6594 22.8916 27.6594C20.6226 27.6594 18.7832 25.8231 18.7832 23.5579V18.3547Z",
    fill: "url(#paint81_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20438 23.8405C8.21718 23.8185 8.23437 23.7996 8.25277 23.7821L8.87195 23.1929C8.87885 23.1863 8.88513 23.1792 8.89038 23.1712C8.95515 23.0734 9.04464 22.864 9.08278 22.9644L9.45144 23.9345C9.50566 24.0772 9.48116 24.2484 9.36594 24.3438C9.21479 24.469 8.99655 24.5866 8.72873 24.5475C8.49597 24.5135 8.31659 24.3531 8.20359 24.2001C8.12721 24.0966 8.13806 23.9542 8.20438 23.8405Z",
    fill: "#C4901A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0188 23.8405C22.0316 23.8185 22.0488 23.7996 22.0672 23.7821L22.6864 23.1929C22.6933 23.1863 22.6996 23.1792 22.7048 23.1712C22.7696 23.0734 22.8591 22.864 22.8972 22.9644L23.2659 23.9345C23.3201 24.0772 23.2956 24.2484 23.1804 24.3438C23.0292 24.469 22.811 24.5866 22.5432 24.5475C22.3104 24.5135 22.131 24.3531 22.018 24.2001C21.9417 24.0966 21.9525 23.9542 22.0188 23.8405Z",
    fill: "#C4901A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_d_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.37182 23.7783L8.90963 22.8237C8.96585 22.7239 9.10866 22.7214 9.16834 22.8192L9.72187 23.7259C9.80327 23.8592 9.80381 24.0321 9.69396 24.1432C9.54986 24.2889 9.33179 24.4369 9.03512 24.4369C8.77729 24.4369 8.55733 24.3041 8.41052 24.1689C8.30172 24.0688 8.29923 23.9071 8.37182 23.7783Z",
    fill: "url(#paint82_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37182 23.7783L8.90963 22.8237C8.96585 22.7239 9.10866 22.7214 9.16834 22.8192L9.72187 23.7259C9.80327 23.8592 9.80381 24.0321 9.69396 24.1432C9.54986 24.2889 9.33179 24.4369 9.03512 24.4369C8.77729 24.4369 8.55733 24.3041 8.41052 24.1689C8.30172 24.0688 8.29923 23.9071 8.37182 23.7783Z",
    fill: "url(#paint83_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_d_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1882 23.7783L22.726 22.8237C22.7823 22.7239 22.9251 22.7214 22.9847 22.8192L23.5383 23.7259C23.6197 23.8592 23.6202 24.0321 23.5104 24.1432C23.3663 24.2889 23.1482 24.4369 22.8515 24.4369C22.5937 24.4369 22.3737 24.3041 22.2269 24.1689C22.1181 24.0688 22.1156 23.9071 22.1882 23.7783Z",
    fill: "url(#paint84_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1882 23.7783L22.726 22.8237C22.7823 22.7239 22.9251 22.7214 22.9847 22.8192L23.5383 23.7259C23.6197 23.8592 23.6202 24.0321 23.5104 24.1432C23.3663 24.2889 23.1482 24.4369 22.8515 24.4369C22.5937 24.4369 22.3737 24.3041 22.2269 24.1689C22.1181 24.0688 22.1156 23.9071 22.1882 23.7783Z",
    fill: "url(#paint85_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.52734 21.2221C6.67318 21.183 7.10547 21.1049 7.47266 21.1439",
    stroke: "#903928",
    strokeWidth: 0.45,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3438 21.2221C20.4896 21.183 20.9219 21.1049 21.2891 21.1439",
    stroke: "#903928",
    strokeWidth: 0.45,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52734 21.1776C6.67318 21.1386 7.10547 21.0605 7.47266 21.0995",
    stroke: "#9F5544",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3438 21.1776C20.4896 21.1386 20.9219 21.0605 21.2891 21.0995",
    stroke: "#9F5544",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.6367 21.2221C11.4909 21.183 11.0586 21.1049 10.6914 21.1439",
    stroke: "#A03B31",
    strokeWidth: 0.45,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4531 21.2221C25.3073 21.183 24.875 21.1049 24.5078 21.1439",
    stroke: "#A03B31",
    strokeWidth: 0.45,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6367 21.1776C11.4909 21.1386 11.0586 21.0605 10.6914 21.0995",
    stroke: "#9F5544",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4531 21.1776C25.3073 21.1386 24.875 21.0605 24.5078 21.0995",
    stroke: "#9F5544",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1097 18.8235C7.09668 18.7948 7.0472 18.7461 6.95345 18.7805C6.8597 18.8149 6.86651 18.8624 6.86361 18.9172C6.8401 19.3625 6.4665 20.3641 5.16025 20.8079C5.09775 20.8261 4.97275 20.8954 4.97275 21.0266V21.4287C4.69509 21.4719 4.447 21.6045 4.25876 21.7961C4.23649 21.5707 4.20461 21.1953 4.19932 20.925C4.19857 20.887 4.19691 20.8436 4.19505 20.7952C4.17751 20.3376 4.14324 19.4433 4.71494 18.5657C5.29004 17.6829 6.07045 17.386 6.51195 17.2219C6.56664 17.2011 6.68851 17.1274 6.73851 16.9993H7.1097V18.8235Z",
    fill: "url(#paint86_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9242 18.8235C20.9111 18.7948 20.8617 18.7461 20.7679 18.7805C20.6742 18.8149 20.681 18.8624 20.6781 18.9172C20.6545 19.3625 20.281 20.3641 18.9747 20.8079C18.9122 20.8261 18.7872 20.8954 18.7872 21.0266V21.4287C18.5095 21.4719 18.2614 21.6045 18.0732 21.7961C18.0509 21.5707 18.0191 21.1953 18.0138 20.925C18.013 20.887 18.0114 20.8436 18.0095 20.7952C17.992 20.3376 17.9577 19.4433 18.5294 18.5657C19.1045 17.6829 19.8849 17.386 20.3264 17.2219C20.3811 17.2011 20.503 17.1274 20.553 16.9993H20.9242V18.8235Z",
    fill: "url(#paint87_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70703 17.0657C6.70703 18.2376 7.0179 19.1637 8.07422 20.0423C9.04365 20.8486 10.2744 20.8458 11.3485 20.8433C12.0749 20.8417 12.7296 20.8402 13.1834 21.0892V21.4255C13.4286 21.4595 13.6515 21.5629 13.8318 21.7153C13.871 21.3923 13.9218 20.7496 13.8944 20.0423C13.8553 19.0345 13.1678 17.2689 11.1991 16.5501C10.7553 16.4001 10.2433 16.3834 10.0428 16.3939H7.37891C7.00784 16.3939 6.70703 16.6947 6.70703 17.0657Z",
    fill: "url(#paint88_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_i_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5234 17.0657C20.5234 18.2376 20.8343 19.1637 21.8906 20.0423C22.8601 20.8486 24.0908 20.8458 25.1649 20.8433C25.8913 20.8417 26.546 20.8402 26.9998 21.0892V21.4255C27.245 21.4595 27.468 21.5629 27.6482 21.7153C27.6874 21.3923 27.7382 20.7496 27.7108 20.0423C27.6717 19.0345 26.9842 17.2689 25.0155 16.5501C24.5717 16.4001 24.0597 16.3834 23.8592 16.3939H21.1953C20.8242 16.3939 20.5234 16.6947 20.5234 17.0657Z",
    fill: "url(#paint89_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 24.8925C8.648 24.8925 8.24645 24.7897 7.90896 24.6098C7.79362 24.5498 7.66974 24.6826 7.74236 24.7897C8.02431 25.2267 8.51558 25.5181 9.0752 25.5181C9.63482 25.5181 10.1261 25.2267 10.408 24.7897C10.4807 24.6783 10.3568 24.5498 10.2414 24.6098C9.90395 24.7897 9.50666 24.8925 9.0752 24.8925Z",
    stroke: "url(#paint90_radial_715_14854)",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8916 24.8925C22.4644 24.8925 22.0629 24.7897 21.7254 24.6098C21.61 24.5498 21.4861 24.6826 21.5588 24.7897C21.8407 25.2267 22.332 25.5181 22.8916 25.5181C23.4512 25.5181 23.9425 25.2267 24.2244 24.7897C24.2971 24.6783 24.1732 24.5498 24.0578 24.6098C23.7204 24.7897 23.3231 24.8925 22.8916 24.8925Z",
    stroke: "url(#paint91_radial_715_14854)",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 24.8925C8.648 24.8925 8.24645 24.7897 7.90896 24.6098C7.79362 24.5498 7.66974 24.6826 7.74236 24.7897C8.02431 25.2267 8.51558 25.5181 9.0752 25.5181C9.63481 25.5181 10.1261 25.2267 10.408 24.7897C10.4807 24.6783 10.3568 24.5498 10.2414 24.6098C9.90395 24.7897 9.50666 24.8925 9.0752 24.8925Z",
    fill: "#89004E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8916 24.8925C22.4644 24.8925 22.0629 24.7897 21.7254 24.6098C21.61 24.5498 21.4861 24.6826 21.5588 24.7897C21.8407 25.2267 22.332 25.5181 22.8916 25.5181C23.4512 25.5181 23.9425 25.2267 24.2244 24.7897C24.2971 24.6783 24.1732 24.5498 24.0578 24.6098C23.7204 24.7897 23.3231 24.8925 22.8916 24.8925Z",
    fill: "#89004E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0023 21.8201C11.5978 21.8201 12.1008 22.2306 12.2377 22.7855C12.2784 22.9445 12.1563 23.0962 11.9936 23.0962H9.95918C9.82972 23.0962 9.72615 22.9778 9.75204 22.8484C9.86671 22.2639 10.3809 21.8201 11.0023 21.8201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8167 21.8201C25.4122 21.8201 25.9153 22.2306 26.0522 22.7855C26.0928 22.9445 25.9708 23.0962 25.808 23.0962H23.7736C23.6442 23.0962 23.5406 22.9778 23.5665 22.8484C23.6812 22.2639 24.1953 21.8201 24.8167 21.8201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8135 22.0679C11.2648 22.0679 11.6273 22.4341 11.6273 22.8816C11.6273 22.9556 11.6162 23.0296 11.5977 23.0962H10.0257C10.0072 23.0259 9.99609 22.9556 9.99609 22.8816C9.99609 22.4341 10.3623 22.0679 10.8135 22.0679Z",
    fill: "url(#paint92_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.628 22.0679C25.0793 22.0679 25.4418 22.4341 25.4418 22.8816C25.4418 22.9556 25.4307 23.0296 25.4122 23.0962H23.8401C23.8216 23.0259 23.8105 22.9556 23.8105 22.8816C23.8105 22.4341 24.1767 22.0679 24.628 22.0679Z",
    fill: "url(#paint93_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3477 22.8816C10.3477 22.6227 10.5548 22.4155 10.8137 22.4155C11.0726 22.4155 11.2798 22.6227 11.2798 22.8816C11.2798 22.9593 11.2613 23.0332 11.228 23.0961H10.4031C10.3662 23.0332 10.3477 22.9593 10.3477 22.8816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1621 22.8816C24.1621 22.6227 24.3692 22.4155 24.6282 22.4155C24.8871 22.4155 25.0942 22.6227 25.0942 22.8816C25.0942 22.9593 25.0757 23.0332 25.0424 23.0961H24.2176C24.1806 23.0332 24.1621 22.9593 24.1621 22.8816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7519 22.2402C10.8098 22.3177 10.6888 22.4121 10.5511 22.515C10.4134 22.618 10.3113 22.6904 10.2533 22.6129C10.1954 22.5355 10.26 22.3892 10.3977 22.2863C10.5354 22.1833 10.694 22.1627 10.7519 22.2402Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7519 22.2402C10.8098 22.3177 10.6888 22.4121 10.5511 22.515C10.4134 22.618 10.3113 22.6904 10.2533 22.6129C10.1954 22.5355 10.26 22.3892 10.3977 22.2863C10.5354 22.1833 10.694 22.1627 10.7519 22.2402Z",
    fill: "url(#paint94_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5683 22.2402C24.6262 22.3177 24.5052 22.4121 24.3675 22.515C24.2298 22.618 24.1277 22.6904 24.0697 22.6129C24.0118 22.5355 24.0765 22.3892 24.2141 22.2863C24.3518 22.1833 24.5104 22.1627 24.5683 22.2402Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5683 22.2402C24.6262 22.3177 24.5052 22.4121 24.3675 22.515C24.2298 22.618 24.1277 22.6904 24.0697 22.6129C24.0118 22.5355 24.0765 22.3892 24.2141 22.2863C24.3518 22.1833 24.5104 22.1627 24.5683 22.2402Z",
    fill: "url(#paint95_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5374 22.7741C11.5074 22.5639 11.3844 22.4055 11.3266 22.3525L11.0898 22.6124L11.1967 22.8203L11.5374 22.7741Z",
    fill: "url(#paint96_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3518 22.7741C25.3218 22.5639 25.1988 22.4055 25.1411 22.3525L24.9043 22.6124L25.0111 22.8203L25.3518 22.7741Z",
    fill: "url(#paint97_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.1027 21.8201C6.50717 21.8201 6.00412 22.2306 5.86726 22.7855C5.82657 22.9445 5.94864 23.0962 6.11139 23.0962H8.14579C8.27525 23.0962 8.37882 22.9778 8.35293 22.8484C8.23827 22.2639 7.72042 21.8201 7.1027 21.8201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9172 21.8201C20.3216 21.8201 19.8186 22.2306 19.6817 22.7855C19.641 22.9445 19.7631 23.0962 19.9258 23.0962H21.9602C22.0897 23.0962 22.1933 22.9778 22.1674 22.8484C22.0527 22.2639 21.5349 21.8201 20.9172 21.8201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29032 22.0679C6.83906 22.0679 6.47656 22.4341 6.47656 22.8816C6.47656 22.9556 6.48766 23.0296 6.50615 23.0962H8.07819C8.09669 23.0259 8.10778 22.9556 8.10778 22.8816C8.10409 22.4341 7.74159 22.0679 7.29032 22.0679Z",
    fill: "url(#paint98_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1067 22.0679C20.6555 22.0679 20.293 22.4341 20.293 22.8816C20.293 22.9556 20.3041 23.0296 20.3226 23.0962H21.8946C21.9131 23.0259 21.9242 22.9556 21.9242 22.8816C21.9205 22.4341 21.558 22.0679 21.1067 22.0679Z",
    fill: "url(#paint99_radial_715_14854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75635 22.8816C7.75635 22.6227 7.54921 22.4155 7.29028 22.4155C7.03136 22.4155 6.82422 22.6227 6.82422 22.8816C6.82422 22.9593 6.84271 23.0332 6.876 23.0961H7.70086C7.73415 23.0332 7.75635 22.9593 7.75635 22.8816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5728 22.8816C21.5728 22.6227 21.3656 22.4155 21.1067 22.4155C20.8478 22.4155 20.6406 22.6227 20.6406 22.8816C20.6406 22.9593 20.6591 23.0332 20.6924 23.0961H21.5173C21.5506 23.0332 21.5728 22.9593 21.5728 22.8816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03418 22.7858C8.03418 22.523 7.82051 22.3479 7.76276 22.2949L7.5 22.549L7.6617 22.8782L8.03418 22.7858Z",
    fill: "url(#paint100_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_f_715_14854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8486 22.7858C21.8486 22.523 21.635 22.3479 21.5772 22.2949L21.3145 22.549L21.4762 22.8782L21.8486 22.7858Z",
    fill: "url(#paint101_linear_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_f_715_14854)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.04425,
    cy: 22.4157,
    rx: 0.354964,
    ry: 0.179644,
    transform: "rotate(-27.914 7.04425 22.4157)",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.04425,
    cy: 22.4157,
    rx: 0.354964,
    ry: 0.179644,
    transform: "rotate(-27.914 7.04425 22.4157)",
    fill: "url(#paint102_radial_715_14854)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_f_715_14854)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.8607,
    cy: 22.4157,
    rx: 0.354964,
    ry: 0.179644,
    transform: "rotate(-27.914 20.8607 22.4157)",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.8607,
    cy: 22.4157,
    rx: 0.354964,
    ry: 0.179644,
    transform: "rotate(-27.914 20.8607 22.4157)",
    fill: "url(#paint103_radial_715_14854)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_14854",
    x: 2.18359,
    y: 1.7312,
    width: 13.9434,
    height: 13.9438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.752941 0 0 0 0 0.478431 0 0 0 0 0.0392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_715_14854",
    x: 2.18359,
    y: 14.7532,
    width: 15.3164,
    height: 15.2656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.294118 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_715_14854",
    x: 3.29297,
    y: 8.09004,
    width: 2.93359,
    height: 3.13433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.411765 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_715_14854",
    x: 12.3031,
    y: 8.62783,
    width: 2.25898,
    height: 2.25874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_715_14854",
    x: 3.64687,
    y: 8.62783,
    width: 2.25898,
    height: 2.25874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_715_14854",
    x: 7.52734,
    y: 8.79663,
    width: 2.71094,
    height: 3.44531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_715_14854",
    x: 8.07578,
    y: 9.07041,
    width: 1.91094,
    height: 2.64531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_715_14854",
    x: 7.32578,
    y: 11.8807,
    width: 3.41094,
    height: 1.42656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_715_14854",
    x: 9.87227,
    y: 8.47656,
    width: 2.75469,
    height: 1.17212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.0862745 0 0 0 0 0.176471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_715_14854",
    x: 5.43555,
    y: 8.47656,
    width: 2.75469,
    height: 1.17212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.0784314 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_715_14854",
    x: 5.55859,
    y: 7.16084,
    width: 2.25469,
    height: 1.0125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_715_14854",
    x: 10.498,
    y: 7.16084,
    width: 2.25469,
    height: 1.0125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_715_14854",
    x: 10.3434,
    y: 8.80332,
    width: 0.735156,
    height: 0.652148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_715_14854",
    x: 11.1008,
    y: 8.86274,
    width: 0.847266,
    height: 0.867773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_715_14854",
    x: 7.05,
    y: 8.80488,
    width: 0.933203,
    height: 0.983252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_715_14854",
    x: 6.36875,
    y: 8.79575,
    width: 0.850391,
    height: 0.659717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_715_14854",
    x: 10.6012,
    y: 7.36338,
    width: 1.91484,
    height: 0.744434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_715_14854",
    x: 5.62852,
    y: 7.36338,
    width: 1.91484,
    height: 0.744434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_715_14854",
    x: 3.19961,
    y: 3.40664,
    width: 3.97773,
    height: 4.18599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_715_14854",
    x: 5.98438,
    y: 2.3728,
    width: 8.26562,
    height: 5.67725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_715_14854",
    x: 16,
    y: 1.7312,
    width: 13.9434,
    height: 13.9438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.752941 0 0 0 0 0.478431 0 0 0 0 0.0392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_715_14854",
    x: 16,
    y: 14.7532,
    width: 15.3164,
    height: 15.2656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.294118 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_715_14854",
    x: 17.1074,
    y: 8.09004,
    width: 2.93359,
    height: 3.13433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.411765 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_715_14854",
    x: 26.1195,
    y: 8.62783,
    width: 2.25898,
    height: 2.25874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_715_14854",
    x: 17.4633,
    y: 8.62783,
    width: 2.25898,
    height: 2.25874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_715_14854",
    x: 21.3438,
    y: 8.79663,
    width: 2.71094,
    height: 3.44531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_715_14854",
    x: 21.8922,
    y: 9.07041,
    width: 1.91094,
    height: 2.64531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_715_14854",
    x: 21.1422,
    y: 11.8807,
    width: 3.41094,
    height: 1.42656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_i_715_14854",
    x: 23.6887,
    y: 8.47656,
    width: 2.75469,
    height: 1.17212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.0862745 0 0 0 0 0.176471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_i_715_14854",
    x: 19.252,
    y: 8.47656,
    width: 2.75469,
    height: 1.17212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.0784314 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_i_715_14854",
    x: 19.375,
    y: 7.16084,
    width: 2.25469,
    height: 1.0125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_i_715_14854",
    x: 24.3145,
    y: 7.16084,
    width: 2.25469,
    height: 1.0125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_715_14854",
    x: 24.1598,
    y: 8.80332,
    width: 0.735156,
    height: 0.652148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_715_14854",
    x: 24.9152,
    y: 8.86274,
    width: 0.847266,
    height: 0.867773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_f_715_14854",
    x: 20.8645,
    y: 8.80488,
    width: 0.933203,
    height: 0.983252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_715_14854",
    x: 20.1832,
    y: 8.79575,
    width: 0.850391,
    height: 0.659717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_715_14854",
    x: 24.4156,
    y: 7.36338,
    width: 1.91484,
    height: 0.744434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_f_715_14854",
    x: 19.443,
    y: 7.36338,
    width: 1.91484,
    height: 0.744434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_f_715_14854",
    x: 17.0141,
    y: 3.40664,
    width: 3.97773,
    height: 4.18599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_f_715_14854",
    x: 19.8008,
    y: 2.3728,
    width: 8.26562,
    height: 5.67725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_i_715_14854",
    x: 3.34922,
    y: 24.3969,
    width: 3.03945,
    height: 3.26006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.647059 0 0 0 0 0.266667 0 0 0 0 0.027451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_i_715_14854",
    x: 17.1637,
    y: 24.3969,
    width: 3.03945,
    height: 3.26006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.647059 0 0 0 0 0.266667 0 0 0 0 0.027451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_f_715_14854",
    x: 12.0238,
    y: 21.7091,
    width: 1.96602,
    height: 1.96699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_f_715_14854",
    x: 25.8383,
    y: 21.7091,
    width: 1.96797,
    height: 1.96699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_f_715_14854",
    x: 4.18594,
    y: 21.7091,
    width: 1.96797,
    height: 1.96699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_f_715_14854",
    x: 18.0023,
    y: 21.7091,
    width: 1.96797,
    height: 1.96699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_f_715_14854",
    x: 7.90039,
    y: 22.6877,
    width: 1.82812,
    height: 2.11743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_f_715_14854",
    x: 21.7148,
    y: 22.6877,
    width: 1.82812,
    height: 2.11743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_715_14854",
    x: 4.32227,
    y: 22.7473,
    width: 9.45703,
    height: 9.68945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_14854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_14854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_715_14854",
    x: 18.1387,
    y: 22.7473,
    width: 9.45703,
    height: 9.68945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_14854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_14854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_f_715_14854",
    x: 6.37656,
    y: 20.9388,
    width: 1.24688,
    height: 0.388721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_f_715_14854",
    x: 20.193,
    y: 20.9388,
    width: 1.24688,
    height: 0.388721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_f_715_14854",
    x: 10.5406,
    y: 20.9388,
    width: 1.24688,
    height: 0.388721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_f_715_14854",
    x: 24.357,
    y: 20.9388,
    width: 1.24688,
    height: 0.388721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_i_715_14854",
    x: 4.1875,
    y: 16.7993,
    width: 2.92188,
    height: 4.99688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.411765 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_i_715_14854",
    x: 18.002,
    y: 16.7993,
    width: 2.92188,
    height: 4.99688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.411765 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_i_715_14854",
    x: 6.70703,
    y: 16.0914,
    width: 7.29531,
    height: 5.62397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72549 0 0 0 0 0.470588 0 0 0 0 0.0313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_i_715_14854",
    x: 20.5234,
    y: 16.0914,
    width: 7.29531,
    height: 5.62397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72549 0 0 0 0 0.470588 0 0 0 0 0.0313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_f_715_14854",
    x: 7.42109,
    y: 24.2944,
    width: 3.3082,
    height: 1.52378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_f_715_14854",
    x: 21.2375,
    y: 24.2944,
    width: 3.3082,
    height: 1.52378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_f_715_14854",
    x: 10.1324,
    y: 22.0934,
    width: 0.735156,
    height: 0.652148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_f_715_14854",
    x: 23.9488,
    y: 22.0934,
    width: 0.735156,
    height: 0.652148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_f_715_14854",
    x: 10.8898,
    y: 22.1525,
    width: 0.847266,
    height: 0.867773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_f_715_14854",
    x: 24.7043,
    y: 22.1525,
    width: 0.847266,
    height: 0.867773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_f_715_14854",
    x: 7.3,
    y: 22.0949,
    width: 0.933203,
    height: 0.983252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_f_715_14854",
    x: 21.1145,
    y: 22.0949,
    width: 0.933203,
    height: 0.983252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_f_715_14854",
    x: 6.61875,
    y: 22.0858,
    width: 0.850391,
    height: 0.659717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_f_715_14854",
    x: 20.4352,
    y: 22.0858,
    width: 0.850391,
    height: 0.659717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_14854"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.312 4.33137) rotate(120.21) scale(13.1265 12.2619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749963,
    stopColor: "#F4A825"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.87451 15.3314) rotate(-45.3265) scale(15.5124 16.772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21782,
    stopColor: "#B1751A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1751A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.34326 12.5501) rotate(155.376) scale(4.12512 5.16578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135849,
    stopColor: "#82480F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82480F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.03055 7.61262) rotate(90) scale(8.5625 20.9685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.70073,
    stopColor: "#AD6C1B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956204,
    stopColor: "#6D4332"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7808 18.175) rotate(98.8107) scale(12.6493 9.37475)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.381034,
    stopColor: "#8D75C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5AA1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.92139 14.4875) rotate(162.777) scale(3.27171 1.37845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3860",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.48863 10.0416) rotate(-164.92) scale(1.68999 1.77236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5B227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8A1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6232 8.93068) rotate(105.35) scale(1.89547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BC21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6381 9.26727) rotate(154.805) scale(7.78495 8.35035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211429,
    stopColor: "#FFDC2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690408,
    stopColor: "#C59D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A721B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.8125 6.01886) rotate(13.1947) scale(6.70835 2.443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79317",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_14854",
    x1: 9.03165,
    y1: 11.6158,
    x2: 9.03165,
    y2: 9.17041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CE27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CB2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.74687 10.9047) rotate(-105.892) scale(2.3225 1.32897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0168227,
    stopColor: "#FFD532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD532",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_715_14854",
    x1: 8.07753,
    y1: 10.9206,
    x2: 8.85655,
    y2: 11.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7AD16",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_715_14854",
    x1: 9.03165,
    y1: 11.6996,
    x2: 9.03165,
    y2: 11.1432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF8A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9AB1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_715_14854",
    x1: 8.36614,
    y1: 13.0463,
    x2: 8.77879,
    y2: 12.2515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C59C25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0207 9.21304) rotate(90) scale(0.739779 1.1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8129 9.28951) rotate(-127.812) scale(0.344652 0.474504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_715_14854",
    x1: 11.731,
    y1: 9.26198,
    x2: 11.4452,
    y2: 9.43811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.04217 9.2128) rotate(90) scale(0.739783 1.17671)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_715_14854",
    x1: 7.72086,
    y1: 9.26187,
    x2: 7.43501,
    y2: 9.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.78049 9.41253) rotate(-90.897) scale(0.450188 0.541144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.93848 4.01876) rotate(137.798) scale(4.72503 0.864494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.395696,
    stopColor: "#9D681E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911046,
    stopColor: "#9D681E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.42881 3.91681) rotate(144.458) scale(3.47698 1.71837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.120488,
    stopColor: "#F4C12A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C12A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6646 2.34863) rotate(115.63) scale(4.60667 6.54071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.627022,
    stopColor: "#C38A1B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38A1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3187 3.49142) rotate(105.909) scale(3.13671 6.57356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131886,
    stopColor: "#FFE139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B820",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0795 8.62628) rotate(-117.848) scale(6.66958 5.96219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.897563,
    stopColor: "#CA9B37",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9B37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1284 4.33137) rotate(120.21) scale(13.1265 12.2619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749963,
    stopColor: "#F4A825"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6909 15.3314) rotate(-45.3265) scale(15.5124 16.772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21782,
    stopColor: "#B1751A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1751A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1597 12.5501) rotate(155.376) scale(4.12512 5.16578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135849,
    stopColor: "#82480F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82480F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.847 7.61262) rotate(90) scale(8.5625 20.9685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.70073,
    stopColor: "#AD6C1B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956204,
    stopColor: "#6D4332"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5972 18.175) rotate(98.8107) scale(12.6493 9.37475)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.381034,
    stopColor: "#8D75C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5AA1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7378 14.4875) rotate(162.777) scale(3.27171 1.37845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3860",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3031 10.0416) rotate(-164.92) scale(1.68999 1.77236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5B227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8A1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4396 8.93068) rotate(105.35) scale(1.89547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BC21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4545 9.26727) rotate(154.805) scale(7.78495 8.35035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211429,
    stopColor: "#FFDC2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690408,
    stopColor: "#C59D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A721B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6289 6.01886) rotate(13.1947) scale(6.70835 2.443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79317",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_715_14854",
    x1: 22.8481,
    y1: 11.6158,
    x2: 22.8481,
    y2: 9.17041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CE27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CB2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5633 10.9047) rotate(-105.892) scale(2.3225 1.32897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0168227,
    stopColor: "#FFD532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD532",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_715_14854",
    x1: 21.8939,
    y1: 10.9206,
    x2: 22.673,
    y2: 11.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7AD16",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_715_14854",
    x1: 22.8481,
    y1: 11.6996,
    x2: 22.8481,
    y2: 11.1432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF8A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9AB1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_715_14854",
    x1: 22.1825,
    y1: 13.0463,
    x2: 22.5952,
    y2: 12.2515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C59C25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8371 9.21304) rotate(90) scale(0.739779 1.1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6293 9.28951) rotate(-127.812) scale(0.344652 0.474504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_715_14854",
    x1: 25.5455,
    y1: 9.26198,
    x2: 25.2596,
    y2: 9.43811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8586 9.2128) rotate(90) scale(0.739783 1.17671)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_715_14854",
    x1: 21.5353,
    y1: 9.26187,
    x2: 21.2495,
    y2: 9.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5949 9.41253) rotate(-90.897) scale(0.450188 0.541144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7529 4.01876) rotate(137.798) scale(4.72503 0.864494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.395696,
    stopColor: "#9D681E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911046,
    stopColor: "#9D681E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2433 3.91681) rotate(144.458) scale(3.47698 1.71837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.120488,
    stopColor: "#F4C12A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C12A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.481 2.34863) rotate(115.63) scale(4.60667 6.54071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.627022,
    stopColor: "#C38A1B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38A1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1351 3.49142) rotate(105.909) scale(3.13671 6.57356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131886,
    stopColor: "#FFE139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B820",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8959 8.62628) rotate(-117.848) scale(6.66958 5.96219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.897563,
    stopColor: "#CA9B37",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9B37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4043 27.0813) rotate(114.075) scale(3.21738 7.50075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92D38"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.24805 32.2688) rotate(-128.267) scale(6.40816 11.0593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.715315,
    stopColor: "#A14357",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9917,
    stopColor: "#A14357"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.49805 26.6438) rotate(156.773) scale(4.19976 2.02403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0850716,
    stopColor: "#96102E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96102E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1387 27.4094) rotate(-150.668) scale(1.88189 0.558365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3158,
    stopColor: "#C43044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E12661",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2207 27.0813) rotate(114.075) scale(3.21738 7.50075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92D38"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0645 32.2688) rotate(-128.267) scale(6.40816 11.0593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.715315,
    stopColor: "#A14357",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9917,
    stopColor: "#A14357"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3145 26.6438) rotate(156.773) scale(4.19976 2.02403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0850716,
    stopColor: "#96102E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96102E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9551 27.4094) rotate(-150.668) scale(1.88189 0.558365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3158,
    stopColor: "#C43044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E12661",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_715_14854",
    x1: 14.0449,
    y1: 25.2688,
    x2: 13.498,
    y2: 26.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.236728,
    stopColor: "#FFBD33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0918 26.8469) rotate(-23.9401) scale(1.27069 5.21318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C23712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8A1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3887 26.675) rotate(139.149) scale(1.50108 0.713247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172154,
    stopColor: "#DD882A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89E2A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_715_14854",
    x1: 27.8613,
    y1: 25.2688,
    x2: 27.3145,
    y2: 26.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.236728,
    stopColor: "#FFBD33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9082 26.8469) rotate(-23.9401) scale(1.27069 5.21318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C23712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8A1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2051 26.675) rotate(139.149) scale(1.50108 0.713247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172154,
    stopColor: "#DD882A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89E2A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.38818 25.8625) rotate(144.004) scale(2.60538 4.00377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260545,
    stopColor: "#AC5B18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64823,
    stopColor: "#C37621"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.44922 25.8625) rotate(-2.43543) scale(1.47081 1.40178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF7D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF7D18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2026 25.8625) rotate(144.004) scale(2.60538 4.00377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260545,
    stopColor: "#AC5B18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64823,
    stopColor: "#C37621"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2637 25.8625) rotate(-2.43543) scale(1.47081 1.40178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF7D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF7D18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0464 21.9719) rotate(105.35) scale(1.65271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BC21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8608 21.9719) rotate(105.35) scale(1.65271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BC21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.65479 1.2793) rotate(-180) scale(1.51563 2.0957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14433,
    stopColor: "#A57E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6E0F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.65479 1.2793) rotate(-180) scale(1.51563 2.0957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14433,
    stopColor: "#A57E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6E0F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0605 23.0071) rotate(173.782) scale(5.87833 9.11879)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204393,
    stopColor: "#FFDF2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD8F12"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.24805 22.2688) rotate(-90) scale(1.21875 1.07626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC8A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC8A16",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0605 21.9875) rotate(-90) scale(0.84375 1.0625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB518",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.248 19.6125) rotate(15.6008) scale(4.99658 2.41356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315353,
    stopColor: "#CA8E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA8E15",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.877 23.0071) rotate(173.782) scale(5.87833 9.11879)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204393,
    stopColor: "#FFDF2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD8F12"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0645 22.2688) rotate(-90) scale(1.21875 1.07626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC8A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC8A16",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.877 21.9875) rotate(-90) scale(0.84375 1.0625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB518",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0645 19.6125) rotate(15.6008) scale(4.99658 2.41356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315353,
    stopColor: "#CA8E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA8E15",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.77979 23.5921) rotate(143.487) scale(1.41978 2.02476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177532,
    stopColor: "#FFD531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C18E17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_715_14854",
    x1: 9.05113,
    y1: 22.7473,
    x2: 9.05113,
    y2: 23.3158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7C225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C225",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5962 23.5921) rotate(143.487) scale(1.41978 2.02476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177532,
    stopColor: "#FFD531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C18E17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_715_14854",
    x1: 22.8675,
    y1: 22.7473,
    x2: 22.8675,
    y2: 23.3158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7C225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C225",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.37402 19.8625) rotate(-156.14) scale(1.77686 2.74416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5B227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8A1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1885 19.8625) rotate(-156.14) scale(1.77686 2.74416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5B227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8A1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.748 17.0814) rotate(109.151) scale(4.39974 5.82999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507601,
    stopColor: "#FFE232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4B225"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5645 17.0814) rotate(109.151) scale(4.39974 5.82999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507601,
    stopColor: "#FFE232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4B225"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.7207 25.0563) rotate(-34.0099) scale(0.541919 1.58947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9F23",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5371 25.0563) rotate(-34.0099) scale(0.541919 1.58947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9F23",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8117 22.5028) rotate(90) scale(0.739779 1.1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6262 22.5028) rotate(90) scale(0.739779 1.1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6019 22.5795) rotate(-127.812) scale(0.344652 0.474504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4183 22.5795) rotate(-127.812) scale(0.344652 0.474504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_715_14854",
    x1: 11.5201,
    y1: 22.5518,
    x2: 11.2342,
    y2: 22.7279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_715_14854",
    x1: 25.3345,
    y1: 22.5518,
    x2: 25.0487,
    y2: 22.7279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.29217 22.5028) rotate(90) scale(0.739783 1.17671)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1086 22.5028) rotate(90) scale(0.739783 1.17671)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_715_14854",
    x1: 7.97086,
    y1: 22.5519,
    x2: 7.68501,
    y2: 22.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_715_14854",
    x1: 21.7853,
    y1: 22.5519,
    x2: 21.4995,
    y2: 22.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.0305 22.7026) rotate(-90.897) scale(0.450188 0.541144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_715_14854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8469 22.7026) rotate(-90.897) scale(0.450188 0.541144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_715_14854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/Family.e39930590d4c6b56211b3dc2f32b2d2a.svg";
export { ForwardRef as ReactComponent };